import { useHasFeatureFlag } from 'featureFlags/useHasFeatureFlag.ts';
import { useHasInLifePermissions } from 'products/common/actions/useHasInLifePermissions.ts';

export const useIsRSimInLifeChangesAvailable = () => {
  const hasPermission = useHasInLifePermissions();

  const inlifeChangesEnabled = useHasFeatureFlag('RsimProductInLifeChanges');

  return hasPermission && inlifeChangesEnabled;
};
